import Binoculars from '@react-spectrum/s2/icons/Binoculars';
import CheckmarkCircle from '@react-spectrum/s2/icons/CheckmarkCircle';
import Email from '@react-spectrum/s2/icons/Email';
import File from '@react-spectrum/s2/icons/File';
import Image from '@react-spectrum/s2/icons/Image';
import Promote from '@react-spectrum/s2/icons/Promote';
import Template from '@react-spectrum/s2/icons/Template';
import UserEdit from '@react-spectrum/s2/icons/UserEdit';
import ViewList from '@react-spectrum/s2/icons/ViewList';
import { iconStyle } from '@react-spectrum/s2/style' with { type: 'macro' };
import type { ReactNode } from 'react';

import { RedditIcon } from '@/components/icons/RedditIcon';
import { InstagramLogo } from '@/components/icons/socials-monochrome/InstagramLogo';

const iconStyles = iconStyle({ size: 'L' });
const mutedIconStyles = iconStyle({ size: 'L', color: 'gray' });

const buildIconMap = (
	styles: ReturnType<typeof iconStyle>,
	redditClassName: string,
	instagramClassName: string,
): Record<string, ReactNode> => ({
	artifact: <CheckmarkCircle styles={styles} />,
	process: <ViewList styles={styles} />,
	job: <Binoculars styles={styles} />,
	ig_comment_watcher_class: <Binoculars styles={styles} />,
	custom_monitor: <Binoculars styles={styles} />,
	campaign: <Promote styles={styles} />,
	subreddit_monitor: <RedditIcon className={redditClassName} />,
	email_plaintext: <Email styles={styles} />,
	email_html: <Template styles={styles} />,
	instagram_post: <InstagramLogo className={instagramClassName} />,
	digital_ad: <Image styles={styles} />,
	// Work the OWNER does, off-platform. A raised hand reads as "stop"; a person
	// doing something reads as "this one is yours".
	request_owner_action: <UserEdit styles={styles} />,
	default: <File styles={styles} />,
});

const panelTypeIconMap = buildIconMap(
	iconStyles,
	'size-9 text-gray-900',
	'size-6 text-gray-900',
);
const mutedPanelTypeIconMap = buildIconMap(
	mutedIconStyles,
	'size-9 text-gray-400',
	'size-6 text-gray-400',
);

export const getPanelIcon = (
	panelType: string,
	options?: { muted?: boolean },
): ReactNode => {
	const map = options?.muted ? mutedPanelTypeIconMap : panelTypeIconMap;
	return map[panelType] ?? map.default;
};
